export default __webpack_public_path__ + "static/media/unga committee.f8cd3d6d.png";